import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { primaryColor } from '../../constants/COLORS';

const Page403 = () => {
  return (
    <Wrapper>
      <h1>Access denied </h1>
      <h2>Sorry, You are not authorised to access this page</h2>
      <Button href="/" danger>
        <ExclamationCircleOutlined /> Back to home
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  padding: 5% 0px;
  align-items: center;
  h1 {
    font-size: 35px;
    margin-bottom: 0px;
    font-weight: 600;
    color: #5b5a60;
  }
  h2 {
    font-size: 18px;
    font-weight: 400;
    color: #5b5a60;
  }
  div {
    padding: 50px 50px;
    background-color: white;
    max-width: 700px;
    border-radius: 5px;
    margin-top: 20px;
    i {
      font-size: 50px;
      margin-bottom: 15px;
      color: ${primaryColor};
    }
  }
`;

export default Page403;
